import { formatNumber } from '@/shared/utils/format/formatNumber';

export function formatPercentage(
  value: number,
  precision = 1,
  suffix?: string | null | false,
): string {
  return `${formatNumber(value, precision)}%${suffix ? ` ${suffix}` : ''}`;
}
